import { ITag } from "@interfaces/user/tag";
import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("userProxyPage") || "{}");
const queryParamsURL = new URLSearchParams(window.location.search);

const isActivePage = window.location.pathname === "/";

const initialState: {
    activePaginationPage: number,
    activePaginationLimit: number,
    activeSortParameter: string,
    activeSearchParameter: string,
    activeTags: ITag["id"][]
} = Object.assign(
    (isActivePage && Object.keys(Object.fromEntries(queryParamsURL)).length)
        ? {
            activePaginationPage: Number(queryParamsURL.get("page") || "1"),
            activePaginationLimit: Number(queryParamsURL.get("limit") || "50"),
            activeSortParameter: queryParamsURL.get("sort") || "",
            activeSearchParameter: queryParamsURL.get("search") || "",
            activeTags: queryParamsURL.getAll("tags").map(Number) || []
        }
        : {
            activePaginationPage: Number(queryParamsLS?.page || "1"),
            activePaginationLimit: Number(queryParamsLS?.limit || "50"),
            activeSortParameter: queryParamsLS?.sort || "",
            activeSearchParameter: queryParamsLS?.search || "",
            activeTags: queryParamsLS?.tags || []
        },
    {}
);

window.localStorage.setItem("userProxyPage", JSON.stringify({
    page: initialState.activePaginationPage,
    limit: initialState.activePaginationLimit,
    sort: initialState.activeSortParameter,
    search: initialState.activeSearchParameter,
    tags: initialState.activeTags
}))

const myProxiesSlice = createSlice({
    initialState,
    name: "myProxiesUserPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<(typeof initialState)["activePaginationPage"]>) {
            window.localStorage.setItem("userProxyPage", JSON.stringify({
                page: action.payload,
                limit: state.activePaginationLimit,
                sort: state.activeSortParameter,
                search: state.activeSearchParameter,
                tags: state.activeTags
            }))
            state.activePaginationPage = action.payload;
        },
        setActivePaginationLimit(state, action: SliceAction<(typeof initialState)["activePaginationLimit"]>) {
            window.localStorage.setItem("userProxyPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: action.payload,
                sort: state.activeSortParameter,
                search: state.activeSearchParameter,
                tags: state.activeTags
            }))
            state.activePaginationLimit = action.payload;
        },
        setActiveSortParameter(state, action: SliceAction<(typeof initialState)["activeSortParameter"]>) {
            window.localStorage.setItem("userProxyPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: state.activePaginationLimit,
                sort: action.payload,
                search: state.activeSearchParameter,
                tags: state.activeTags
            }))
            state.activeSortParameter = action.payload;
        },
        setActiveSearchParameter(state, action: SliceAction<(typeof initialState)["activeSearchParameter"]>) {
            window.localStorage.setItem("userProxyPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: state.activePaginationLimit,
                sort: state.activeSortParameter,
                search: action.payload,
                tags: state.activeTags
            }))
            state.activeSearchParameter = action.payload;
        },
        changeActiveTags(state, action: SliceAction<(typeof initialState)["activeTags"][0]>) {
            if (state.activeTags.includes(action.payload)) {
                state.activeTags = state.activeTags.filter(item => item !== action.payload)  
            } else {
                state.activeTags.push(action.payload)
            }

            window.localStorage.setItem("userProxyPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: state.activePaginationLimit,
                sort: state.activeSortParameter,
                search: state.activeSearchParameter,
                tags: state.activeTags
            }))
        },
    },
});

const { reducer, actions } = myProxiesSlice;

export default reducer;

export const {
    setActivePaginationPage,
    setActivePaginationLimit,
    setActiveSearchParameter,
    setActiveSortParameter,
    changeActiveTags
} = actions;
